import { failure, success } from "./commandResult";

export const handleHelperResult = (result, defaultMessage) => {
    if (!result.success) {
        const msg = (result.error && result.error.Message) || defaultMessage || 'Unspecified error';

        return failure(msg);
    }

    return success();
};

